class QueryLoadMoreGrid {
  constructor(element) {
    this.element = element;
    this.terms = this.element.querySelectorAll('[data-element="query-load-more-grid-term"]');
    this.list = this.element.querySelector('[data-element="query-load-more-grid-list"]');
    this.listType = this.list.dataset.type;
    this.listTaxonomy = this.list.dataset.taxonomy;
    this.listTermId = 0;
    this.listPage = 2;
    this.listPerPage = this.list.dataset.perPage;
    this.listPerLoad = this.list.dataset.perLoad;
    this.loadMore = this.element.querySelector('[data-element="query-load-more-grid-load-more"]');
    this.loadMoreBtn = this.element.querySelector('[data-element="query-load-more-grid-load-more-btn"]');
    this.loadMoreLoader = this.element.querySelector('[data-element="query-load-more-grid-load-more-loader"]');
    this.rest = wpRestApi; // eslint-disable-line
  }

  init() {
    if (null !== this.loadMore) {
      this.loadMoreBtn.addEventListener('click', this.onLoadMoreBtnClick.bind(this));
    }

    this.terms.forEach((term) => {
      term.addEventListener('click', this.onTermClick.bind(this, term));
    });
  }

  onLoadMoreBtnClick() {
    this.loadItems();
  }

  onTermClick(term) {
    if (term.classList.contains('is-active')) {
      return;
    }

    this.removeAllTermsActive();
    term.classList.add('is-active');
    this.clearPosts();
    this.showLoadMore();
    this.listPage = 1;
    this.listTermId = term.dataset.id;
    this.loadNewsletter = true;
    this.loadItems();
  }

  loadItems() {
    this.showLoader();

    const url = new URL(this.rest.url + 'customer-story/load-more');
    url.searchParams.append('type', this.listType);
    url.searchParams.append('taxonomy', this.listTaxonomy);
    url.searchParams.append('term_id', this.listTermId);
    url.searchParams.append('page', this.listPage);
    url.searchParams.append('per_page', this.listPerPage);
    url.searchParams.append('per_load', this.listPerLoad);

    fetch(url.href, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      return response.json();
    }).then((data) => {
      if (null !== data.html) {
        this.list.insertAdjacentHTML('beforeend', data.html);
      }

      if (true === data.hideBtn) {
        this.hideLoadMore();
      }

      this.listPage++;
      this.hideLoader();
    }).catch((error) => {
      console.error(error);
      this.hideLoader();
    });
  }

  clearPosts() {
    this.list.replaceChildren();
  }

  removeAllTermsActive() {
    this.terms.forEach((term) => {
      term.classList.remove('is-active');
    });
  }

  hideLoadMore() {
    if (null === this.loadMore) {
      return;
    }

    this.loadMore.classList.add('query-load-more-grid__load-more--hidden');
  }

  showLoadMore() {
    if (null === this.loadMore) {
      return;
    }

    this.loadMore.classList.remove('query-load-more-grid__load-more--hidden');
  }

  hideLoader() {
    this.loadMoreLoader.classList.remove('query-load-more-grid__loader--show');
  }

  showLoader() {
    this.loadMoreLoader.classList.add('query-load-more-grid__loader--show');
  }
}

const queryLoadMoreGrid = {
  init() {
    const queryLoadMoreGridElements = document.querySelectorAll('[data-module="query-load-more-grid"]');

    if (queryLoadMoreGridElements && queryLoadMoreGridElements.length) {
      queryLoadMoreGridElements.forEach((element) => {
        const queryLoadMoreGridElement = new QueryLoadMoreGrid(element);
        queryLoadMoreGridElement.init();
      });
    }
  },
};

export default queryLoadMoreGrid;
